<template>
  <center>
    <!-- <div v-if="duringSubmit" class="loading">
      <Loading />
    </div> -->
    <div
      v-if="isLoggedIn || handleLogin()"
      class="card card-body agatrs-card-style"
    >
      <Header pageTitle="Search" class="card-container"></Header>

      <!-- 3rd Row -->
      <div class="d-flex justify-content-md-center">
        <div class="col-md-3">
          <label for="LogisticsUser">Assigned Logistics User</label>
          <v-select
            id="LogisticsUser"
            v-model="selectedAssignedLogisticsUser"
            name="AssignedLogisticsUserDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="assignedLogisticsUserOptions"
            placeholder="Select"
          >
            <template v-slot:option="option">
              {{ option.nameLabel }}
            </template>
          </v-select>
        </div>

        <div class="col-md-3">
          <label for="FinanceUser">Assigned Finance User</label>

          <v-select
            id="FinanceUser"
            v-model="selectedAssignedFinanceUser"
            name="AssignedFinanceUserDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="assignedFinanceUserOptions"
            placeholder="Select"
          >
            <template v-slot:option="option">
              {{ option.nameLabel }}
            </template>
          </v-select>
        </div>
      </div>
      <div>
        <div class="col-md-3 justify-content-md-center justify-content-end">
          <label for="OrderNumber">Order Number</label>
          <el-input
            id="OrderNumber"
            v-model="selectedOrderId"
            name="OrderNumber"
            type="textarea"
            placeholder="Ex: 1,2,3"
          ></el-input>
        </div>
      </div>
      <!-- 7th Row (Search and Clear Buttons) -->
      <div class="row more-top-padding">
        <div
          class="
            col-md-12
            d-flex
            justify-content-md-center justify-content-end
            col-6
          "
        >
          <base-button
            @click="initializeAllData()"
            type="danger"
            v-b-popover.hover.top="'Reset all fields!'"
          >
            <i class="tim-icons icon-alert-circle-exc"></i> Clear
          </base-button>

          <base-button
            @click="search()"
            :disabled="this.duringSubmit"
            type="primary"
            v-b-popover.hover.right="'Search results will appear below.'"
          >
            <i class="tim-icons icon-zoom-split"></i> Search
          </base-button>
        </div>
      </div>
      <hr />
      <br />

      <div>
        <h3>Search Results</h3>
        <SearchShowOrdersReassignment ref="childEvents"></SearchShowOrdersReassignment>
      </div>
    </div>
  </center>
</template>
  
  <script>
import SearchShowOrdersReassignment from "@/pages/SearchShowOrdersReassignment.vue";
import Header from "@/components/App/Header.vue";
import { mapGetters, mapActions } from "vuex";
import { Select, Option, Tooltip } from "element-ui";
import Util from "@/util/util";
import Treeselect from "@riophae/vue-treeselect";
import Loading from "src/components/LoadingPanel";
import { createCipheriv } from "crypto";
import Axios from 'axios';

export default {
  name: "Search",
  components: {
    Header,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    SearchShowOrdersReassignment,
    Treeselect,
    Loading,
  },
  mounted() {
    if (!this.user) {
      this.getUserByEmail();
    }

    this.getAllStatuses();
    this.getAllCountries();
    this.getAllOperationTheatres();
    this.getPaymentMethods();
    this.getLssTypes();
    this.getLogisticsUsers(false);
    this.getFinanceUsers(false);
    this.getPartnerNationUsers();
    this.getUsers();
    this.getFiscalYears();
    this.clearSearchCriteria();
    this.clearSearchResults();
    this.getJointStaffOrganizations();
  },
  data() {
    return {
      duringSubmit: false,
      selectedAcsaRequisitionNumber: "",
      selectedBuyOrSell: "",
      buyOrSellOptions: [
        {
          id: "BUY",
          name: "Buy",
        },
        {
          id: "SELL",
          name: "Sell",
        },
      ],
     
      selectedOrderId: "",
      selectedAssignedLogisticsUser: "",
      selectedAssignedFinanceUser: "",
      organizationIds: [],
      organizationId: null,
      statusOptions: [],
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "authentication/isLoggedIn",
      partnerNationOptions: "countries/allCountries",
      operationTheaterOptions: "operationTheaters/allOperationTheatres",
      methodOfPaymentOptions: "paymentmethod/paymentMethods",
      lsssTypeOptions: "lsstype/allLssTypes",
      assignedLogisticsUserOptions: "users/logisticsUsers",
      assignedFinanceUserOptions: "users/financeUsers",
      createdByOptions: "users/allUsers",
      fiscalYears: "fiscalYears/fiscalYears",
      searchResults: "orders/searchResults",
      searchCriteria: "orders/searchCriteria",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
    }),
    fiscalYearStart() {
      return this.selectedFiscalYear
        ? new Date(this.selectedFiscalYear - 1, 9, 1).toISOString()
        : null;
    },
    fiscalYearEnd() {
      return this.selectedFiscalYear
        ? new Date(this.selectedFiscalYear, 8, 30).toISOString()
        : null;
    },
    selectedLogisticsUserLabel() {
      let selectedUser;
      if (this.selectedAssignedLogisticsUser) {
        selectedUser = this.assignedLogisticsUserOptions.find(
          (user) => user.id === this.selectedAssignedLogisticsUser
        );
      }
      return selectedUser
        ? selectedUser.nameLabel
        : "No Logistics user selected";
    },
    selectedFinanceUserLabel() {
      let selectedUser;
      if (this.selectedAssignedFinanceUser) {
        selectedUser = this.assignedFinanceUserOptions.find(
          (user) => user.id === this.selectedAssignedFinanceUser
        );
      }
      return selectedUser
        ? selectedUser.nameLabel
        : "No Logistics user selected";
    },
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
      getAllOperationTheatres: "operationTheaters/getAllOperationTheatres",
      getPaymentMethods: "paymentmethod/getPaymentMethods",
      getLssTypes: "lsstype/getLssTypes",
      getLogisticsUsers: "users/getLogisticsUsers",
      getFinanceUsers: "users/getFinanceUsers",
      getPartnerNationUsers:"users/getPartnerNationUsers",
      getUsers: "users/getUsers",
      getFiscalYears: "fiscalYears/getFiscalYears",
      setSearchCriteria: "orders/setSearchCriteria",
      clearSearchCriteria: "orders/clearSearchCriteria",
      // getSearchResults: "orders/getSearchResults",
      getSearchResultsReassignment: "orders/getSearchResultsReassignment",
      clearSearchResults: "orders/clearSearchResults",
      getUserByEmail: "users/getUserByEmail",
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
    }),
    handleLogin() {
      if (!this.isLoggedIn) {
        this.$router.push("Login");
      }
    },
    initializeAllData() {
      Object.assign(this.$data, this.$options.data());
    },
    async getAllStatuses() {
      const response = await Axios.get("/api/orderstatuses");
      this.statusOptions = response.data;
    },
    isPhoneNumber(data) {
      var pattern = /^[0-9()+]{1,25}$/;
      return pattern.test(data);
    },
    isNumeric(data) {
      var pattern = /^[0-9]+$/i;
      return pattern.test(data);
    },
    async search() {
      // if (this.duringSubmit) {
      //   return; // don't want user to keep click searching if the previous search hasn't return yet.
      // }
      if(this.$loaderApp.checkoutPendingCount() !== 0) {
        return;
      }
      this.clearSearchResults();
      this.$refs.childEvents.disableEverything();
      var arrayOrderId = (this.selectedOrderId == "") ? [] : this.selectedOrderId.split(',');
      for(var i=0; i<arrayOrderId.length; i++) {
        if(!this.isNumeric(arrayOrderId[i])) {
          this.$toast.error('Order IDs must be separated by a comma.  Eg. 1,2,3');
          return;
        }
      }
  
      let searchQuery = {
        orderIds: arrayOrderId,
        logisticsUserId: this.selectedAssignedLogisticsUser,
        financeUserId: this.selectedAssignedFinanceUser,
      };

      if (!Util.isNullOrEmpty(this.searchCriteria.SearchText)) {
        searchQuery.SearchText = this.searchCriteria.SearchText;
      }

      if (!Util.isNullOrEmpty(this.searchResults)) {
        searchQuery.ResultsPerPage = this.searchResults.pageSize;
      }
      this.$refs.childEvents.handleNewSearch();
      this.setSearchCriteria(searchQuery);

      this.duringSubmit = true;
      this.$loaderApp.addRequest();
      try {
        await this.getSearchResultsReassignment();
      
        if (!Util.isNullOrEmpty(this.searchResults.results)) {
          this.$refs.childEvents.enableEverything();
        } else {
          this.$refs.childEvents.disableEverything();
        }
      } catch(err) {
        if(err) {
          this.$toast.error(err);
        }
      }
      this.duringSubmit = false;
      this.$loaderApp.completeRequest();
    },
 
    // DFS to find the parent
    findParent(child) {
      if (child.id === this.organizationId) return child;
      let len = child.children.length;
      if (len > 0) {
        for (let i = 0; i < len; i++) {
          let children = child.children[i];
          if (children.id === this.organizationId) {
            return children;
          } else {
            let ret = this.findParent(children);
            if (ret.id === this.organizationId) {
              return ret;
            }
          }
        }
      }
      return child;
    },
    // DFS to find all the children of a parent
    findAllChildrenId(children) {
      for (let i = 0; i < children.children.length; i++) {
        let child = children.children[i];
        this.organizationIds.push(child.id);
        this.findAllChildrenId(child);
      }
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    filterApprover() {
      if (this.organizationId !== undefined) {
        this.organizationIds = [];

        // find the parent
        var parent = this.findParent(this.jointStaffOrganizations[0]);

        // find the children;
        this.organizationIds.push(parent.id);
        this.findAllChildrenId(parent);
      } else {
        this.organizationIds = [];
      }
    },
  },
};
</script>
  